import { Carservice, CarserviceFamily } from 'rest-client';

import { languages } from '@app/i18n/lang-loader';

export function getName(
  carService: Carservice | CarserviceFamily,
  lang: string
): string {
  if (lang === languages.ca) {
    return carService.name_ca;
  }

  if (lang === languages.en) {
    return carService.name_en;
  }

  if (lang === languages.fr) {
    return carService.name_fr;
  }

  return carService.name_es;
}

export function getServiceDescription(
  carService: Carservice,
  lang: string
): string {
  if (lang === languages.ca) {
    return carService.description_ca;
  }

  if (lang === languages.en) {
    return carService.description_en;
  }

  if (lang === languages.fr) {
    return carService.description_fr;
  }

  return carService.description_es;
}

export function getServiceLongDescription(
  carService: Carservice,
  lang: string
): string {
  if (lang === languages.ca) {
    return carService.long_description_ca;
  }

  if (lang === languages.en) {
    return carService.long_description_en;
  }

  if (lang === languages.fr) {
    return carService.long_description_fr;
  }

  return carService.long_description_es;
}

export function getServiceCheckInDescription(
  carService: Carservice,
  lang: string
): string {

  const check_in_es:any = carService.check_in_es;
  const check_in_ca:any = carService.check_in_ca;
  const check_in_en:any = carService.check_in_en;
  const check_in_fr:any = carService.check_in_fr;

  if (lang === languages.ca) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_ca.warning_before_buy[0].body;
  }

  if (lang === languages.en) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_en.warning_before_buy[0].body;
  }

  if (lang === languages.fr) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_fr.warning_before_buy[0].body;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
  return check_in_es.warning_before_buy[0].body;
}

export function getServiceCheckInTitle(
  carService: Carservice,
  lang: string
): string {

  const check_in_es:any = carService.check_in_es;
  const check_in_ca:any = carService.check_in_ca;
  const check_in_en:any = carService.check_in_en;
  const check_in_fr:any = carService.check_in_fr;

  if (lang === languages.ca) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_ca.warning_before_buy[0].name;
  }

  if (lang === languages.en) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_en.warning_before_buy[0].name;
  }

  if (lang === languages.fr) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
    return check_in_fr.warning_before_buy[0].name;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-member-access
  return check_in_es.warning_before_buy[0].name;
}
